export default {
  locale: 'en-ZA',

  moment: {
    months:
      'January_February_March_April_May_June_July_August_September_October_November_December'.split(
        '_'
      ),
    monthsShort:
      'Jan._Feb._Mar._Apr._May_Jun._Jul._Aug._Sep._Oct._Nov._Dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
      '_'
    ),
    weekdaysShort: 'Su._Mo._Tu._We._Th._Fr._Sa.'.split('_'),
    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: 'HH:mm',
      LTS: 'HH:mm:ss',
      L: 'YYYY/MM/DD',
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY HH:mm',
      LLLL: 'DDDD, DD MMMM YYYY HH:mm',
    },
    calendar: {
      sameDay: "[today at] LT [O'Clock]",
      sameElse: 'L',
      nextDay: "[tomorrow at] LT [O'Clock]",
      nextWeek: "dddd [at] LT [O'Clock]",
      lastDay: "[yesterday at] LT [O'Clock]",
      lastWeek: "[last] dddd [at] LT [O'Clock]",
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
      dow: 1, // Monday is the first day of the week.
      doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/locales/en-ZA.js